import requests from './httpService';
const ParkService = {
  getAllPark() {
    return requests.get(`/park/list`);
  },
   getAllActivePark(body) {
    return requests.post(`/park/activelist`,body);
  },
  getParks(body){
    return requests.post('/park/get',body); 
  },
  cretePark(body){
    return requests.post('/park/add',body); 
  },
  getAllParkById(id,body){
    return requests.post(`/park/list/${id}`,body); 
  },
  deletePark(body){
    return requests.delete(`/park/${body._id}`); 
    
  },
  getParkById(id) {
    return requests.get(`/park/${id}` );
  },
  getQRcodebyById(body) {
    return requests.post(`/ticketbooking/getqrcodebystatus`,body );
  },

  getAdvbyById(body) {
    return requests.post(`/ticketbooking/getAdvatagement`,body );
  },
  getAppointmentDetailsById(body) {
    return requests.post(`/doctorbooking/getqrcodebystatus`,body );
  },

  qrCode(id) {
    return requests.get(`/park/qr/${id}` );
  },
  findParkList(body){
    return requests.post(`/park/find`,body); 
  },
  upadePark(body) {
    return requests.put(`/park/${body._id}`,body); 
  }, 
  addAllProfileId(body) {
    return requests.post(`/park/listbyprofileid`,body);
  },
  uploadImage(body) {
    return requests.post('/upload/uploadimage', body);
  },
};

export default ParkService;
